// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Components
import { FormActions, FormActionsItem, Trans } from '../..';
import { Modal } from '../../modals';
import { Button, ButtonPrimary } from 'texkit/dist/components/Buttons';

// Styles
import '../DpsVerifyAddressModal/dps-verify-address-modal.scss';
import {
  states,
  counties,
  statesWithProvinces,
} from '../../../../lib/data/agencyData/DPS';

function DpsAddressCantConfirm(props) {
  const {
    onSuccess,
    closeModal,
    id = 'AddressCantConfirm',
    modal: { data },
    ...rest
  } = props;

  if (!data || !data.enteredAddress) {
    return false;
  }

  const handleSuccess = () => {
    closeModal(id);
    onSuccess({
      ...data.enteredAddress,
      state:
        states.find(state => state.value === data.enteredAddress.state) ||
        statesWithProvinces.find(
          state => state.value === data.enteredAddress.state
        ),
      county: counties.find(
        county =>
          county.label === (data.enteredAddress.county || '').toUpperCase()
      ) || { label: 'OTHER', value: '999' },
    });
  };

  const close = () => {
    closeModal(id);
  };

  return (
    <Modal
      {...rest}
      id={id}
      disableOnClickOutside={true}
      className="dps-verify-address-modal"
    >
      <h2 className="h1 modal-title">
        <Trans file="Modals" id="AddressCantConfirmTitle" />
      </h2>
      <div className="modal-content">
        <div>
          <h3 style={{ marginTop: 0 }}>
            <Trans file="Modals" id="AddressTwoInvalidBody" />
          </h3>
          <h4>
            {data.enteredAddress.streetAddress} <br />
            {data.enteredAddress.addressLine2}
            {data.enteredAddress.addressLine2 &&
            data.enteredAddress.addressLine2.length ? (
              <br />
            ) : (
              ''
            )}
            {data.enteredAddress.city}, {data.enteredAddress.state}{' '}
            {data.enteredAddress.zipFive} {data.enteredAddress.county}
          </h4>
        </div>
        <FormActions align="center">
          <FormActionsItem>
            <ButtonPrimary onClick={close}>
              <Trans file="Labels" id="Edit" />
            </ButtonPrimary>
          </FormActionsItem>
          <FormActionsItem>
            <Button onClick={handleSuccess}>
              <Trans file="Labels" id="Confirm" />
            </Button>
          </FormActionsItem>
        </FormActions>
      </div>
    </Modal>
  );
}

const mapStateToProps = ({ modal }) => ({ modal });
const mapDispatchToProps = dispatch =>
  bindActionCreators({ closeModal }, dispatch);

DpsAddressCantConfirm.propTypes = {
  id: PropTypes.string,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
  modal: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DpsAddressCantConfirm);
